var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"404-container",staticStyle:{"text-align":"center","margin-top":"300px"}},[_c('h1',[_vm._v("404 NotFound 请您检查路由地址是否正确")]),_c('br'),_c('h2',[_vm._v("您也可以联系微信：15921291928")])])
}]

export { render, staticRenderFns }